import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-room',
	templateUrl: './icon-room.component.svg',
})
export class IconRoomComponent {}
